export const POST_HOG_EVENT_NAME = {
  VIRTUAL_PAGE_VIEW: '$pageview',
  SEARCH: 'Search Performed',
  SEARCH_NO_RESULTS: 'Search No Results',
  VIEW_ITEM: 'Product Viewed',
  ADD_TO_CART: 'Product Added to Cart',
  REMOVE_FROM_CART: 'Product Removed from Cart',
  VIEW_CART: 'Cart Viewed',
  BEGIN_CHECKOUT: 'Checkout Started',
  ADD_SHIPPING_INFO: 'Shipping Info Added',
  ADD_PAYMENT_INFO: 'Payment Info Added',
  PURCHASE: 'Order Completed',
  SIGN_UP: 'User Signed Up',
  LOGIN: 'User Logged In',
  LOGOUT: 'User Logged Out',
};

export const DINTERO_PAYMENT_FLAG = {
  KEY: 'use_dintero_payment',
  CONTROL: 'control',
  TEST: 'test',
  STORAGE_KEY: 'dintero_payment_group',
  STORAGE_TTL_MS: 24 * 60 * 60 * 1000,
};

export const FEATURE_FLAGS_TIMEOUT_MS = 2000;
